var map = {
	"./AVosKids_logo.jpg": 4463,
	"./Amazon-button.svg": 4782,
	"./AppStore-button.svg": 6403,
	"./Chirp/Chirp.png": 747,
	"./Chirp/ChirpLogo.svg": 2828,
	"./Chirp/Laura.svg": 5836,
	"./Chirp/OwlkidsLogo.svg": 7363,
	"./Dekuple/Background02.svg": 7210,
	"./Dekuple/GraduateBoy_AVosKids.gif": 4257,
	"./Dekuple/GraduateGirl_AVosKids.gif": 7005,
	"./Dekuple/GraduateGirl_noVideo.png": 5250,
	"./Dekuple/MontessoriLogo_de.svg": 1500,
	"./Dekuple/MontessoriLogo_en.svg": 2852,
	"./Dekuple/MontessoriLogo_fr.svg": 7829,
	"./Dekuple/aZnHYF-2.png": 9255,
	"./Dekuple/faq.svg": 8813,
	"./Dekuple/logo.png": 9835,
	"./EdokiSquares.svg": 4396,
	"./Edoki_logo.svg": 1246,
	"./GooglePlay-button.svg": 2393,
	"./ILEM/Abby.gif": 9071,
	"./ILEM/Background.svg": 7562,
	"./ILEM/ILoveEnglish_Logo.svg": 5183,
	"./ILEM/Leo.gif": 6682,
	"./ILEM/LogoBayard.svg": 2479,
	"./ILEM/help_icon_yellow.svg": 3138,
	"./JMC/Addition.svg": 4979,
	"./JMC/BackgroundJungle.svg": 8424,
	"./JMC/Division.svg": 9066,
	"./JMC/JMC_Character.gif": 2825,
	"./JMC/JMC_Character_750px.gif": 9893,
	"./JMC/JungleLogo.svg": 1111,
	"./JMC/Multiplication.svg": 9876,
	"./JMC/Subtraction.svg": 7618,
	"./Logo_Bayard.svg": 5948,
	"./Logo_Sailer.svg": 6604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;